import { isApiError, unwrap } from "@sagot/api-client";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "../../../../session/session-provider";
import { useWorkspaceId } from "../../../../session/workspace-context";

const STALE_MS = 30_000;

export const frameOriginsKey = (wsId: string) => ["ws", wsId, "settings", "frame-origins"] as const;

/**
 * `GET /v1/webapp/frame-origins` (M29 E20): the sites allowed to frame the workspace's chat. Fails fast, because a 404
 * is the answer "Secure launch is off for this workspace" and the Settings menu uses it to hide the entry.
 */
export function useFrameOrigins(enabled = true) {
  const api = useApi();
  const wsId = useWorkspaceId();
  return useQuery({ queryKey: frameOriginsKey(wsId), queryFn: () => unwrap(api.GET("/v1/webapp/frame-origins")), enabled, retry: false, staleTime: STALE_MS });
}

/** The platform flag `secure_launch` is off for this workspace (the API answers 404 `not_found`). */
export function isSecureLaunchOff(error: unknown): boolean {
  return isApiError(error) && error.status === 404;
}
